import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import loginReducer from './slices/loginSlice';
import confirmReducer from './slices/confirmSlice';
import themeReducer from './slices/themeSlice';
import textSearchReducer from './slices/textSearchSlice';
import walletReducer from './slices/walletSlice';
import transactionReducer from './slices/transactionSlice';
import walletTransactionsReducer from './slices/walletTransactionsSlice';
import walletTransactionSearchReducer from './slices/walletTransactionSearchSlice';
import blocksReducer from './slices/blocksSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    login: loginReducer,
    confirm: confirmReducer,
    theme: themeReducer,
    textSearch: textSearchReducer,
    wallet: walletReducer,
    transaction: transactionReducer,
    walletTransactions: walletTransactionsReducer,
    walletTransactionSearch: walletTransactionSearchReducer,
    blocks: blocksReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 